"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RunState = void 0;
var RunState;
(function (RunState) {
    RunState["STARTED"] = "STARTED";
    RunState["ERROR"] = "ERROR";
    RunState["FINISHED"] = "FINISHED";
})(RunState = exports.RunState || (exports.RunState = {}));
//# sourceMappingURL=schedule-types.js.map